import {combineReducers} from 'redux';
import {createReducer} from 'typesafe-actions';

import {sysSetInfo, sysSetLoaded} from './actions';
import ISystemInfo = MyTypes.ISystemInfo;

const loaded = createReducer<boolean>(false) //
  .handleAction(sysSetLoaded, (state, action) => action.payload);

const info = createReducer<ISystemInfo>({
  code: undefined,
  message: undefined,
}) //
  .handleAction(sysSetInfo, (state, action) => ({
    ...action.payload,
  }));

const systemReducer = combineReducers({
  info,
  loaded,
});

export default systemReducer;
export type SystemState = ReturnType<typeof systemReducer>;



// WEBPACK FOOTER //
// ./src/store/system/reducer.ts